import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.click-to-play-slider' ).length ) {
        $( '.click-to-play-slider' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'loop',
            gap: '20px',
            perPage: 2,
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              768: {
                perPage: 1,
                gap: '1rem',
              },
            },
          } );
          slider.on( 'overflow', function( isOverflow ) {
            if ( !isOverflow ) {
              slider.options = {
                arrows: isOverflow,
                pagination: isOverflow,
                drag: isOverflow,
                clones: isOverflow ? undefined : 0,
                focus: 0,
              };
            }
          } );
          slider.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'click-to-play-slider', COMPONENT );
} )( app );
